import { BaseTable } from 'components/modules/BaseTable';
import { useContext, useEffect, useState } from 'react';
import { useHistoryViewData } from '../../utils/useHistoryViewData';
import { BreadCrumbContext } from '..';
import { TablePaginationConfig, ColumnsType } from 'antd/lib/table/Table';
import ScoreViewOption, { INIT_FILTER_OPTIONS } from '../common/ScoreViewOption';
import { createColumns } from './createColumns';
import { Divider, Typography } from 'antd';

// antd の Tree data の表示を使うための型
type DataSource = AppStatusModal.HistoryView['history'][number];
type Props = {
    category: App.AppsCategory;
};

export const HistoryView: React.FC<Props> = ({ category }) => {
    const { breadcrumb } = useContext(BreadCrumbContext);
    const [historyView] = useHistoryViewData(
        breadcrumb?.history?.type === 'Student' ? breadcrumb.uuid : breadcrumb?.history?.uuid ?? '',
        breadcrumb?.history?.type === 'Student' ? breadcrumb?.history?.uuid : breadcrumb.uuid
    );
    const [filterOptions, setFilterOptions] = useState<string[]>(INIT_FILTER_OPTIONS);
    const [filterLoading, setFilterLoading] = useState(false);

    const application = getApplication(
        category,
        breadcrumb?.history?.type === 'Student' ? breadcrumb : breadcrumb.history
    );

    useEffect(() => {
        setFilterLoading(false);
    }, [filterLoading]);

    const [pagination, setPagination] = useState<TablePaginationConfig>({
        ...historyView.pagination,
        showTotal: (total, range) => {
            return `全${total}件中 ${range[0]}-${range[1]} 件`;
        },
        onChange: (page, pageSize) => {
            setPagination((pagination) => ({
                ...pagination,
                current: page,
                pageSize,
            }));
        },
    });

    const handleChangeViewOption = (value: string) => {
        setFilterLoading(true);
        setFilterOptions((prev) => {
            if (prev?.length > 0 && prev?.includes(value)) {
                return [...prev.filter((item) => item !== value)];
            }
            return [...prev, value];
        });
    };

    const columns: ColumnsType<DataSource> = createColumns(filterOptions, application);

    return (
        <div>
            {breadcrumb.history?.type === 'Application' ? (
                <Typography.Title level={3}>{breadcrumb?.history?.name}</Typography.Title>
            ) : (
                <Typography.Title level={3}>{breadcrumb?.history?.name} さんの学習結果</Typography.Title>
            )}
            <Divider style={{ marginTop: '0.5rem', marginBottom: '2rem' }} />
            <ScoreViewOption onChange={handleChangeViewOption} />

            <BaseTable
                emptyDescription={''} // 通常空になることはない
                rowKey='uuid'
                columns={columns}
                dataSource={historyView.history}
                loading={historyView.loading || filterLoading}
                pagination={pagination}
                tableLayout='auto'
                scroll={{ x: 'max-content' }}
                showTopScroll={true}
            />
        </div>
    );
};

const getApplication = (
    category: App.AppsCategory,
    breadcrumb: AppStatusModal.Breadcrumb | undefined
): App.ForAdmin | App.ForManager | undefined => {
    const applications: any[] = category.applications ?? [];
    return applications.find((app) => app.uuid === breadcrumb?.uuid);
};
